<div class="main-container">
    <ion-card>
        <ion-card-header
            color="{{error.errorPriority == 'error' ? 'danger' : (error.errorPriority == 'information' ? 'primary' : 'warning') }}">
            <ion-card-title class="ion-display-flex ion-align-items-center">
                <ion-icon name="information-circle-outline" size="large"></ion-icon>
                {{ "components.errorDetails.errorCardDetails.titlePrefix" | translate }} {{ error.descriptionKey | translate | lowercase }}
            </ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <ion-grid>
                <app-error-detail-rule [content]="error.tenant.name"
                                       ruleNameKey="components.errorDetails.errorCardDetails.ruleName.tenant"/>

                <app-error-detail-rule [content]="error.fullApplicationName"
                                       ruleNameKey="components.errorDetails.errorCardDetails.ruleName.application"/>

                <ng-content/>

                <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.type">
                    <form [formGroup]="detailForm">
                        <ion-select (ionChange)="changeErrorType()" formControlName="errorType" interface="popover">
                            @for (errorType of errorTypes; track errorType.value) {
                                <ion-select-option
                                    [value]="errorType.value">{{ errorType.translationKey | translate }}
                                </ion-select-option>
                            }
                        </ion-select>
                    </form>
                </app-error-detail-rule>
            </ion-grid>
            <div class="solveContainer">
                @if (!error.isSolved) {
                    <ion-button color="secondary" (click)="onSolveErrorClick()" [disabled]="isSolvingError">
                        {{ "components.errorDetails.errorCardDetails.solveButton" | translate }}
                    </ion-button>
                } @else {
                    <p>
                        <ion-icon size="large" name="checkmark-circle-outline" color="success"></ion-icon>
                        {{ "components.errorDetails.errorCardDetails.solvedText" | translate }}
                    </p>
                }
            </div>
        </ion-card-content>
    </ion-card>

    <ion-card>
        <ion-card-header color="medium">
            <ion-card-title class="ion-display-flex ion-align-items-center">
                <ion-icon name="time-outline" size="large"></ion-icon>
                {{ "components.errorDetails.occurredCard.title" | translate }}
            </ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <cdk-virtual-scroll-viewport class="scrollable-content" itemSize="47" maxBufferPx="800" minBufferPx="400">
                <ion-list>
                    <ion-item *cdkVirtualFor="let specificError of error.errorLogs">
                        {{ specificError.occurredAsString }}
                    </ion-item>
                </ion-list>
            </cdk-virtual-scroll-viewport>
        </ion-card-content>
    </ion-card>
</div>
